import React from 'react';
import iconIntagram from '../assets/intagram-icon_2x.png';
import iconDrinkaware from '../assets/drinkaware-logo_2x.png';

function Footer() {
  return (
    <footer className="footer-links">
      <div>
        <a 
          href="https://compliance.carlsberggroup.com/externals/en-hq/cookies?id=f8709873-26b4-4dce-9fb0-d59170f8ee30"
          target="_blank"
          rel="noopener noreferrer"
        >Cookie Policy</a> |{' '}
        <a 
          href="https://compliance.carlsberggroup.com/externals/en-hq/terms?id=f8709873-26b4-4dce-9fb0-d59170f8ee30"
          target="_blank"
          rel="noopener noreferrer"
        >Terms</a> |{' '}
        <a 
          href="https://compliance.carlsberggroup.com/externals/en-hq/?id=f8709873-26b4-4dce-9fb0-d59170f8ee30"
          target="_blank"
          rel="noopener noreferrer"
        >Privacy Policy</a>
      </div>
      <div className="social-links">
        <a
          href="https://www.instagram.com/carlsberguk"
          className="intagram-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={iconIntagram} className="instagram-icon" alt="Instagram" />
        </a>
        <a
          href="https://www.drinkaware.co.uk"
          className="drinkaware-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={iconDrinkaware} className="drinkaware-icon" alt="Drinkaware" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;